module.exports = __webpack_public_path__ + "img/app7.79e45069.png";